<script>
    import LySection from '../layouts/components/LySection.svelte';
    import LyContent from '../layouts/components/LyContent.svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import * as Icons from 'lucide-svelte';
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.BottleWine}>Gott-Modus</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>
            Für alle Aufgaben der <strong>heiligen Programmierer</strong>.
        </LyP>
    </LySection>
</LyContent>
